import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class pagoService {

    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/pago/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/pago/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/pago/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };



    async pagoResumen(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/pago/pagoResumen?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pagoDetallado(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/pago/pagoDetallado?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async pago_proveedores(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/pago/pago-proveedores?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerCompraNroSerie(idProveedor) {
        const response = await axios
            .get(`${ERP}tesoreria/pago/compra/${idProveedor}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pago_credito(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/pago/pago-credito?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    /******* TRANSACCIONES ******/


}

export default new pagoService();